import { service } from '@ember/service';
import Route from '@ember/routing/route';
// This is for types. Anything we have custom may show an error.
import type { Store as StoreService } from '@warp-drive/core';
import type RouterService from '@ember/routing/router-service';

export default class AuthenticatedSyfPostEnrollmentRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;

  model() {
    return this.modelFor('authenticated.syf');
  }
}
